var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrandlocal50(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    fill: "#0ecb81",
    id: "svg_1",
    r: 23.27
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.57,12l-5.39,17.9s-0.69,2.75 0.6,4.36c1.28,1.61 3.33,2.21 5.04,2.21l11.7,0l1.62,-5l-8.92,0c-1.41,0 -1.96,-1.14 -1.58,-2.5c0.38,-1.35 0.99,-2.75 0.99,-2.75l11.1,0l-15.16,-14.22z",
    fill: "#ffffff",
    id: "svg_4",
    strokeWidth: 12
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrandlocal50);
export default __webpack_public_path__ + "static/media/errandlocal50.309f9cc76ed0b2da898334c86581db3b.svg";
export { ForwardRef as ReactComponent };